module.exports = __webpack_public_path__ + "static/media/avatar.8d913f1d.png";